var Preconditions = require('./Preconditions.js'); 

function SessionStorage()
{
    this.is_window_available = true;

    try
    {
        window;
    }
    catch(err)
    {
        this.is_window_available = false;
    }

    this.backstop_map = new Map();
}

SessionStorage.prototype.getItem = function(key)
{
    Preconditions.checkString(key);

    if ( this.is_window_available )
    {
        return window.sessionStorage.getItem(key);
    }

    return this.backstop_map.get(key);
}

SessionStorage.prototype.setItem = function(key, value)
{
    Preconditions.checkString(key);

    if ( Preconditions.isNull(value) )
    {
        this.deleteItem(key);
        return;
    }

    Preconditions.checkString(value);

    if ( this.is_window_available )
    {
        window.sessionStorage.setItem(key, value);
        return;
    }

    this.backstop_map.set(key,value);
}

SessionStorage.prototype.deleteItem = function(key)
{
    Preconditions.checkString(key);

    if ( this.is_window_available )
    {
        window.sessionStorage.removeItem(key);
        return;
    }

    this.backstop_map.delete(key);
}

SessionStorage.prototype.get = function(key, default_value)
{
    let as_str = this.getItem(key);

    if ( Preconditions.isNull(as_str) ) return default_value;

    try
    {
        return JSON.parse(as_str);
    }
    catch(err)
    {
        return default_value;
    }
}

SessionStorage.prototype.set = function(key, value)
{
    Preconditions.checkString(key);

    if ( Preconditions.isNull(value) )
    {
        this.deleteItem(key);
        return;
    }

    this.setItem(key, JSON.stringify(value));
}

SessionStorage.prototype.delete = function(key)
{
    Preconditions.checkString(key);
    this.deleteItem(key);
}

SessionStorage.prototype.has = function(key)
{
    Preconditions.checkString(key);
    return this.get(key,null) != null;
}

module.exports = SessionStorage;